import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import Animated, {
  Extrapolation,
  interpolate,
  interpolateColor,
  useAnimatedStyle,
  useDerivedValue,
  type SharedValue,
} from 'react-native-reanimated';
import { useThemeColors } from '../../../shared/theme';

interface MenuFlowHeaderBackgroundSet2Props {
  scrollY: SharedValue<number>;
  scrollRange: number;
  fullHeaderHeight: number;
  collapsedHeaderHeight: number;
  topInset: number;
}

function MenuFlowHeaderBackgroundSet2Component({
  scrollY,
  scrollRange,
  fullHeaderHeight,
  collapsedHeaderHeight,
  topInset,
}: MenuFlowHeaderBackgroundSet2Props) {
  const colors = useThemeColors();
  const color_primary = colors?.primary ?? '#35858b';
  const color_primary_light = colors?.primaryLight ?? color_primary;
  const full_height_num = fullHeaderHeight;
  const collapsed_height_num = collapsedHeaderHeight;

  const progress = useDerivedValue(() => {
    'worklet';
    return interpolate(scrollY.value, [0, scrollRange], [0, 1], Extrapolation.CLAMP);
  });

  const height_style = useAnimatedStyle(() => {
    'worklet';
    return {
      height:
        interpolate(progress.value, [0, 1], [full_height_num, collapsed_height_num], Extrapolation.CLAMP) +
        topInset,
    };
  });

  const color_style = useAnimatedStyle(() => {
    'worklet';
    return {
      backgroundColor: interpolateColor(progress.value, [0, 1], [color_primary, color_primary_light], 'RGB'),
    };
  });

  return (
    <Animated.View style={[styles.wrap, height_style]} pointerEvents="none">
      <Animated.View style={[StyleSheet.absoluteFillObject, styles.rounded, color_style]} />
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    elevation: 10,
    overflow: 'hidden',
    width: '100%',
  },
  rounded: {
    borderBottomLeftRadius: '10%',
    borderBottomRightRadius: '10%',
  },
});

export const MenuFlowHeaderBackgroundSet2 = memo(MenuFlowHeaderBackgroundSet2Component);
